export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-watermelonfalls.623e15fb.png";